"use client";

import { isRouteErrorResponse, useRouteError } from "react-router";

import { HeroTitle, HeroDescription } from "@/components/hero";

export function ErrorText() {
  const error = useRouteError();

  let title = "Oops!";
  let description = "Sorry, an unexpected error has occurred.";

  if (isRouteErrorResponse(error)) {
    title = String(error.status);
    description = error.statusText;
  }

  return (
    <>
      <HeroTitle>{title}</HeroTitle>
      {!!description && <HeroDescription>{description}</HeroDescription>}
    </>
  );
}
